






































































export default {
  name: "ImageDisplay",
  components: {},
  props: {
    images: {
      required: true,
      type: Array
    },
    description: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      VUE_APP_BACKEND_URI: process.env.VUE_APP_BACKEND_URI,
      selectedIndex: 0,
      isShown: false
    };
  },
  watch: {
    // Reset the selectedIndex back to 0 to always show the first image when another plant type is viewed.
    $route(to, from) {
      if (from.name === "Details") {
        this.selectedIndex = 0;
      }
    }
  },
  methods: {
    scrollRight() {
      if (this.selectedIndex >= this.images.length - 1) {
        return;
      }

      this.selectedIndex++;

      this.$refs.images.scrollLeft += 84;
    },
    scrollLeft() {
      if (this.selectedIndex <= 0) {
        return;
      }

      this.selectedIndex--;

      this.$refs.images.scrollLeft -= 84;
    }
  }
};
